/* eslint-disable import/no-anonymous-default-export */
export default {
	//Portal de Usuários

	ID: "ID",

	DOCUMENT: "Documento",
	PLAN_VALIDITY: "Validade do plano",
	SIZE: "Tamanho",
	VERIFY: "Verificar",
	WEEK: "Semana",
	WEEKS: "Semanas",
	DAY: "Dia",
	DAY_OF_WEEK: "Dia da semana",
	NUMBER_OF_WEEKS: "Número de semanas",
	REGISTER: "Cadastrar",
	USER: "Cliente",
	USERS: "Clientes",
	INVALID_USER: "Cliente inválido",
	INVALID_ADMINISTRATOR: "Administrador inválido",
	CREATE_USER: "Cadastrar cliente",
	CREATE_ADMINISTRATOR: "Cadastrar administrador",
	CREATE_PROSPECT: "Cadastrar interessado",
	ORDER_CODE: "Ordem",
	EDIT_USER: "Editar Cliente",
	CREATE_USER_SUCCESS: "Seu usuário foi criado com sucesso!",
	CREATE_PROSPECT_SUCCESS: "Interessado foi criado com sucesso!",
	UPDATE_USER_SUCCESS: "Seu usuário foi alterado com sucesso!",
	MARK_ALL_AS_READ: "Marcar todas como lidas",
	NOTIFICATIONS: "Notificações",
	NOTIFICATION_LIST: "Lista de Notificações",
	REGISTER_NOTIFICATION: "Cadastrar Notificação",
	NOTIFICATIONS_TITLE: "Titulo da notificação",
	NOTIFICATIONS_DESCRIPTION: "Mensagem da notificação",
	NOTIFICATIONS_CREATOR: "Criador da notificação",
	NOTIFICATION_TYPE: "Tipo da notificação",
	NOTIFICATION_NO_USER_OR_CLIENT_WARNING:
		"Notificações devem ter, pelo menos, um Cliente ou uma empresa",
	MESSAGE: "Mensagem",
	MESSAGE_DOCUMENT_MANDATORY: "Mensagem é de preenchimento obrigatório!",
	QUANTITY_OF_USERS: "Quantidade de clientes",
	FREE_APPOINTMENT: "Marque esta caixa para ativar a próxima consulta grátis para o cliente",
	INTEREST_HISTORY: "Histórico de Interesses",
	INTEREST_DATE: "Registro Interesse",
	INTERESTS_LIST: "Histórico de Interesses",

	MY_PROFILE: "Meu perfil",
	SETTINGS: "Configurações",
	LOGOUT: "Log Out",
	EDIT: "Editar",
	EDIT_PATIENT: "Editar dados do paciente",
	SAVE_PATIENT: "Salvar dados do paciente",
	SAVE_EDIT: "Salvar edição",
	OTHERS: "Outros",
	OTHER: "Outro",
	ATENTION: "Atenção",
	CLOSE: "Fechar",
	INVALID: "Inválido",
	CONFIRM: "Confirmar",
	CONFIRM_CHANGE: "Confirmar Troca",
	CONFIRM_PASSWORD_CHANGE: "Confirmar Troca de Senha",
	CONFIRM_EMAIL_CHANGE: "Confirmar Troca de Email",
	CONFIRM_PASSWORD_CHANGE_TO: "Confirmar troca de senha para",
	CHANGE_PASSWORD: "Alterar senha de login",
	CHANGE_PASSWORD_TITLE: "Redefinição de senha",
	CONFIRM_CHANGE_PASSWORD: "Confirmar e redefinir senha",
	CHANGE_EMAIL: "Alterar email de login",
	CHANGE_EMAIL_PATIENT: "Alterar email de login do paciente",
	ACTUAL_EMAIL: "Email atual",
	NEW_EMAIL: "Novo email",
	CONFIRM_NEW_EMAIL: "Confirmar novo email",
	PASSWORD_CHANGE_SUCCESS: "Senha trocada com sucesso!",
	EMAIL_CHANGE_SUCCESS: "Email trocado com sucesso!",
	VERIFY_PASSWORD_EMAIL: `Paciente deve acessar o email de cadastro para obter a nova senha`,
	ONLY_NO_APPOINTMENT_PATIENTS: `Sem consulta agendada?`,
	ALL_PATIENTS: `Todos os pacientes`,
	REDEFINE_PASSWORD: "Redefinir Senha",
	OLD_PASSWORD: "Sua atual senha",
	NEW_PASSWORD: "Sua nova senha",
	NEW_PASSWORD_SHORT: "Nova senha",
	ENTER_NEW_PASSWORD_SHORT: "Digite a nova senha...",
	DISPLAY_NEW_PASSWORD_SHORT: "Coloque a nova senha",
	NEW_PASSWORD_CONFIRM: "Confirmação da nova senha",
	ENTER_NEW_PASSWORD_CONFIRM: "Digite a confirmação da nova senha...",
	DISPLAY_NEW_PASSWORD_CONFIRM: "Coloque a confirmação da nova senha",
	YOUR_PASSWORD: "Sua senha",
	CONFIRM_NEW_PASSWORD: "Confirmar nova senha",
	CONFIRM_PASSWORD: "Confirmar senha",
	FILL_ALL_FIELDS_RESET_PASSWORD:
		"Digite todos os campos para redefinir a sua senha.",
	FILL_ALL_FIELDS_CHANGE_PASSWORD:
		"Digite todos os campos para alterar sua senha.",
	FILL_ALL_FIELDS_CREATE_PASSWORD:
		"É necessário informar a senha e a confirmação de senha!",
	PASSWORD_CONFIRMATION_FAILED:
		'"Sua nova senha" e "Confirmar nova senha" não são iguais.',
	FILL_ALL_FIELDS_CHANGE_EMAIL:
		"Digite todos os campos para alterar seu email.",
	EMAIL_CONFIRMATION_FAILED:
		'"Seu novo email" e "Confirmar novo email" não são iguais.',
	RESET_TOKEN_INVALID:
		"Token inválido. Você deve acessar esta página através do link enviado por email. Caso necessário, solicite uma nova redefinição de senha na página inicial.",
	RESET_PASSWORD_SUCCESS: "Senha redefinida com sucesso. Redirecionando para tela inicial...",

	CREATE_FOLLOW_UP: "Criar Acompanhamento",
	CREATE_APPOINTMENT: "Nova Consulta",
	NO_APPOINTMENTS: "Você está sem consultas cadastradas :(",
	REGISTER_PATIENT: "Cadastrar Paciente",
	EDIT_REGISTERED_DATA: "Editar Dados Cadastrais",
	APPOINTMENT_CREATED_SUCCESS: "Consulta cadastrada com sucesso",

	PATIENT_LIST: "Lista de Pacientes",
	FOLLOW_UP_LIST: "Lista de Acompanhamentos",
	APPOINTMENT_LIST: "Lista de Consultas",
	EVALUATION_LIST: "Lista de Avaliações",
	EVALUATION_LIST_PATIENT: "Lista de Avaliações do Paciente",
	DIET_LIST: "Lista de Dietas",
	TRAINING_LIST: "Lista de Treinos",

	LOGIN_DATA: "Dados de Acesso",
	PERSONAL_DATA: "Dados Pessoais",
	FIRST_NAME: "Nome",
	FIRST_NAME_MANDATORY: "Nome é de preenchimento obrigatório!",
	LAST_NAME: "Sobrenome",
	LAST_NAME_MANDATORY: "Sobrenome é de preenchimento obrigatório!",
	NUTRITIONIST_CREDENTIAL: "CRN",
	PERSONAL_DOCUMENT: "CPF",
	COMPANY_DOCUMENT: "CNPJ",
	COMPANY_NAME: "Nome da empresa",
	SEGMENT: "Segmento",
	PERSONAL_EMAIL: "Email pessoal",
	PERSONAL_EMAIL_CONFIRMATION: "Confirmar email pessoal",
	PERSONAL_PHONE: "Telefone pessoal",

	PERSONAL_ADDRESS: "Endereço Pessoal",
	POSTAL_CODE: "CEP",
	STREET: "Logradouro",
	DISTRICT: "Bairro",
	NUMBER: "Número",
	COMPLEMENT: "Complemento",
	CITY: "Cidade",
	STATE: "UF",

	GENDER: "Gênero",
	MALE: "Masculino",
	FEMALE: "Feminino",
	BIRTHDAY: "Data de Nascimento",
	AGE: "Idade",
	YEARS: "anos",
	EMAIL: "Email",
	ENTER_EMAIL: "Digite seu email...",
	ENTER_PASSWORD: "Digite sua senha...",
	PHONE: "Telefone",
	WHATSAPP: "WhatsApp",
	WEIGHT: "Peso",
	HEIGHT: "Altura",

	CLINIC_DATA: "Dados do Consultório",
	ATTENDANCE_TIME: "Horários de atendimento",
	EMAIL_CLINIC: "Email do consultório",
	PHONE_CLINIC: "Telefone do consultório",
	ADDRESS_CLINIC: "Endereço do Consultório",

	SHOW_PERSONAL_ADDRESS: "Mostrar endereço pessoal para os pacientes?",
	SHOW_OFFICE_ADDRESS: "Mostrar endereço do escritório para os pacientes?",
	SHOW_PHONE: "Mostrar telefone para os pacientes?",
	DAYS_NOTIFY_RETURN: "Notificar retorno a partir de quantos dias?",
	DAYS_NOTIFY_FOLLOWUP:
		"Notificar envio de acompanhamento a partir de quantos dias?",

	NEW_FILE: "Novo arquivo",
	FILE_NAME: "Nome do arquivo",
	NEXT_APPOINTMENT: "Próxima consulta",
	NEXT_APPOINTMENT_DATE: "Data da próxima consulta",
	APPOINTMENT_DATE: "Data da consulta",
	FOLLOW_UP_DATE: "Data do acompanhamento",
	ADD_COMMENT: "Adicionar comentário",
	USER_COMMENT: "Comentário do Nutricionista",

	OBSERVATIONS: "Observações",
	GENERAL_DATA: "Dados Gerais",
	APPOINTMENTS: "Consultas",
	EVALUATIONS: "Avaliações",
	FOLLOW_UPS: "Acompanhamentos",
	DIETS: "Dietas",
	DIET: "Dieta",
	COMPARATIVE: "Comparativo",
	COMPARE_FOLLOW_UP: "Comparação de Acompanhamentos",
	GENERATE_COMPARATIVE: "Gerar Comparativo",

	REMOVE_DIET: "Remover dieta",

	EVALUATION_DETAIL: "Detalhe da Avaliação",
	EVALUATION_DATE: "Data da Avaliação",
	ADD_NEW_DIET: "Adicionar nova dieta",
	MUST_HAVE_DIET: "Dieta deve ser adicionada",
	SUCCESS_ADD_DIET: "Dieta adicionada!",
	ADD_NEW_ATTACHMENT: "Adicionar novo anexo",
	ADD_NEW_TRAINING: "Adicionar novo treino",
	REMOVE_ATTACHMENT: "Remover anexo",
	REMOVE_TRAINING: "Remover treino",
	ATTACHMENT_DESCRIPTION: "Descrição do anexo",
	MUST_HAVE_ATTACHMENT: "Anexo deve ser adicionado",
	MUST_HAVE_ATTACHMENT_DESCRIPTION: "Descrição do anexo deve ser preenchida",
	SUCCESS_ADD_ATTACHMENT: "Anexo adicionado!",
	SUCCESS_ADD_TRAINING: "Treino adicionado!",
	FAIL_ADD_ATTACHMENT: "Anexo inválido!",
	REMOVE_ATTACHMENT_SUCCESS: "Anexo removido com sucesso",
	ENTER_DESCRIPTION: "Digite a descrição",
	DESCRIPTION_MANDATORY: "Descrição é de preenchimento obrigatório!",
	FOLLOW_UP_DETAIL: "Detalhes do Acompanhamento",
	QUIZ: "Questionário",
	ANSWER_QUIZ: 'Favor responder todas as perguntas em "Questionário"',
	YES: "Sim",
	NO: "Não",
	FOLLOWING_DIET: "Está conseguindo seguir a dieta?",
	FEELING_HUNGRY: "Está sentindo fome em algum momento do dia?",
	DRINKING_WATER: "Está ingerindo a quantidade mínima de água por dia?",
	FREE_MEALS: "Quantas refeições livres teve na semana?",
	BATHROOM_DAILY: "Está indo no banheiro todos os dias?",
	PERFORMANCE_TRAINING: "Está conseguindo fazer os treinos?",
	DOING_AEROBICS: "Está conseguindo fazer o aeróbico?",
	CHANGE_SOMETHING: "Gostaria de mudar alguma coisa na dieta?",

	DATE_TIME: "Data / Hora",
	SEND_DATE: "Data de Envio",
	LOCAL: "Local",
	ADDRESS: "Endereço",
	CREATION_DATE: "Data da criação",
	FROM_THIS_DATE: "A partir de ...",
	TO_THIS_DATE: "Até ...",

	IS_REQUIRED: "é obrigatório",
	MUST_BE_SELECTED: "deve ser selecionado",
	MESURES: "Medidas",
	BASIC_MESURES: "Medidas Básicas",
	OBJECTIVES: "Objetivo(s)",
	PATIENT_OBJECTIVES: "Objetivo(s) do Paciente",

	// END_APPOINTMENT: 'Local da Consulta',
	END_APPOINTMENT: "Finalizar Consulta",
	END_REGISTER: "Finalizar Cadastro",
	SUCCESS_CREATE_PATIENT: "Novo paciente foi registrado!",
	IS_PATIENT_REGISTERED: "Paciente já está cadastrado?",
	ERROR: "Erro",
	SUCCESS: "Sucesso",
	CLIENT_DATA_SAVED_SUCCESS: "Dados da empresa salvos com sucesso",
	USER_DATA_SAVED_SUCCESS: "Dados do cliente salvos com sucesso",
	QUIZ_DATA_SAVED_SUCCESS: "Dados do questionário salvos com sucesso",
	ERROR_INVALID_FILE_TYPE: "Tipo de anexo não permitido",

	OK: "OK",
	CANCEL: "Cancelar",
	TYPE: "Tipo",

	FILE_TYPE: "Tipo de Arquivo",
	DRAG_FILE_HERE: "Arraste ou clique aqui para enviar o arquivo!",
	DRAG_IMAGE_HERE: "Arraste a imagem aqui ou clique!",
	DELETE_IMAGE_QUESTION: "Deseja deletar a imagem?",
	ATTACH_IMAGES: 'Favor anexar todas as imagens em "Imagens"!',
	SELECTED_FILES: "Arquivo(s) selecionados(s)",
	ATTACHED_FILES: "Arquivo(s) anexados(s) anteriormente",
	ATTACHED_FILES_2: "Arquivo(s) anexados(s)",
	IMAGE: "Imagem",
	IMAGES: "Imagens",

	CURRENT_HEIGHT: "Altura",
	CURRENT_WEIGHT: "Peso",
	CUTANEOUS_FOLD: "Dobras Cutâneas",
	SUBSCAPULARIS_FOLD: "Dobra Subescapular",
	TRICEPS_FOLD: "Dobra Tricipital",
	CHEST_FOLD: "Dobra Toráxica",
	MID_AXILLARY_FOLD: "Dobra Axilar Média",
	SUPRAILIAC_FOLD: "Dobra Suprailíaca",
	ABDOMINAL_FOLD: "Dobra Abdominal",
	MID_FEMORAL_FOLD: "Dobra Femoral Média",
	BICEPS_FOLD: "Dobra Bíceps",
	CALF_FOLD: "Dobra Panturrilha",
	RELAXED_ARM: "Braço Relaxado",
	CONTRACTED_ARM: "Braço Contraído",
	LEFT_ARM_RELAXED: "Braço esquerdo relaxado",
	LEFT_ARM_FLEXED: "Braço esquerdo contraído",
	RIGHT_ARM_RELAXED: "Braço direito relaxado",
	RIGHT_ARM_FLEXED: "Braço direito contraído",
	CHEST: "Tórax",
	WAIST: "Cintura",
	ABDOMEN: "Abdomen",
	HIP: "Quadril",
	MID_THIGH: "Coxa Medial",
	CALF: "Panturrilha",

	BODY_INDICES: "Índices corporais",
	MID_CUTANEOUS_FOLD: "Médias Dobras Cutâneas",
	FAT_AND_LEAN_MASS_CALCULATION: "Cálculo de Gordura e Massa Magra",
	BODY_FAT: "Gordura Corporal",
	PERCENTAGE_BODY_FAT: "% de Gordura Corporal",
	LEAN_MASS: "Massa Magra",
	PERCENTAGE_LEAN_MASS: "% de Massa Magra",
	BODY_DENSITY: "Densidade Corporal",
	ANSWER_NEW_FOLLOW_UP: "Responder novo acompanhamento",
	FOLLOW_UP_REGISTERED_SUCCESS: "Acompanhamento cadastrado com sucesso!",

	GO_BACK: "Voltar",

	START: "Início",
	END: "Fim",
	START_TIME: "Hora de Início",
	START_DATE: "Data de Início",
	END_TIME: "Hora de Fim",
	END_DATE: "Data Fim",
	DURATION_DAYS: "Duração em dias",
	LAST_ONE_F: "Última",
	LAST_ONE_M: "Último",
	CONTINUE: "Continuar",

	NEXT_STEP: "Próxima etapa",

	CONVERSATION: "Conversa",
	FREE_TEXT: "Texto Livre",
	EVALUATION: "Avaliação",
	ATTACHMENTS: "Anexos",
	ATTACHMENTS_LIST: "Lista de Anexos",
	SET_RETURN: "Agendar retorno",
	CLOSING: "Fechamento",
	RECOVER_PASSWORD: "Esqueci minha senha",

	ENTER: "Entrar",
	CREATE_ACCOUNT: "Criar Conta",
	DISPLAY_PASSWORD: "Coloque sua senha",
	DISPLAY_CONFIRM_PASSWORD: "Coloque sua confirmação de senha!",
	PASSWORD_MUST_BE_EQUAL: "Senhas precisam ser iguais",
	DISPLAY_EMAIL: "Coloque seu email",
	DISPLAY_REGISTERED_EMAIL: "Informe o email cadastrado",
	INVALID_LOGIN: "Login inválido",
	SUCCESS_NEW_PASSWORD: "Sua nova senha foi enviada para o email informado!",
	FORGOT_PASSWORD_SUCCESS: "Você receberá um email para alterar sua senha. Verifique sua caixa de emails.",

	MUST_CHOOSE_AUTOCOMPLETE: "Um item deve ser selecionado.",

	NEW_PATIENT: "Novo Paciente",
	SELECT_A_PATIENT: "Selecione um paciente",
	PATIENT_MUST_BE_LINKED: "Consulta deve ter um paciente vinculado",

	SELECT_FILE_TYPE: "Selecione um tipo para",

	ONLINE: "Online",
	APPOINTMENT_ADDRESS: "Local da Consulta",
	CUSTOM_ADDRESS: "Local Personalizado",

	SEARCH: "Consultar",

	LOGIN_ERROR: "Erro ao efetuar login. ",
	CEP_FETCH_ERROR: "Erro ao efetuar busca por CEP",
	CREATE_PATIENT_ERROR: "Erro ao criar paciente",
	IS_APPOINTMENT_NOW: "A consulta começará neste exato momento?",

	INCLUDE_CANCELED: "Incluir canceladas?",
	NOT_INCLUDE_CANCELED: "Ocultar canceladas?",

	NOT_POSSIBLE_RESCHEDULE: "Não foi possivel reagendar a consulta",
	DELETE_ATTACHMENT_QUESTION: "Deseja excluir este anexo?",
	ACTION: "Ação",

	SHOW_ONLY_NOT_READ: "Mostrar apenas não lidas",
	SHOW_ALL_NOTIFICATIONS: "Mostrar todas as notificações",
	SHOW_MORE: "Mostrar mais",

	NONE_M: "Nenhum",
	NONE_F: "Nenhuma",
	ALL_M: "Todos",
	ALL_F: "Todas",
	ACTIVE: "Ativos",
	INACTIVE: "Inativos",

	NO_PATIENT_ERROR: "Nenhum paciente vinculado",
	INVALID_START_HOUR: "O horário de início deve ser menor que o de término",
	INVALID_DATE: "A data da consulta deve ser maior ou igual a data atual",
	INVALID_PERSONAL_EMAIL: "Favor inserir um email pessoal válido!",
	INVALID_COMMERCIAL_EMAIL: "Favor inserir um email comercial válido!",
	USER_ADDRESS_PERSONAL_EMPTY: "Favor preencher o endereço Pessoal!",
	USER_ADDRESS_OFFICE_EMPTY: "Favor preencher o endereço do Consultório!",
	USER_ADDRESS_PERSONAL_INVALID: "Endereço Pessoal inválido!",
	USER_ADDRESS_OFFICE_INVALID: "Endereço do Consultório inválido!",
	OFFICE_HOURS_EMPTY: "É necessário informar o horário de atendimento!",
	PERSONAL_PHONE_INFO_EMPTY: "É necessário informar o telefone pessoal!",
	COMMERCIAL_PHONE_INFO_EMPTY: "É necessário informar o telefone comercial!",
	COMMERCIAL_PHONE_INVALID: "Telefone comercial inválido!",
	PERSONAL_PHONE_INVALID: "Telefone pessoal inválido!",
	EMAIL_PERSONAL_EMPTY: "É necessário informar o email pessoal!",
	EMAIL_COMMERCIAL_EMPTY: "É necessário informar o email comercial!",
	EMAIL_PERSONAL_CONFIRMATION_EMPTY: "É necessário confirmar o email pessoal!",
	EMAIL_PERSONAL_CONFIRMATION_INVALID:
		'"Email pessoal" e "Confirmação email pessoal" precisam ser iguais!',
	FULL_NAME_MANDATORY: "Nome e Sobrenome são de preenchimento obrigatório!",
	COMPANY_DOCUMENT_MANDATORY: "CNPJ é de preenchimento obrigatório!",
	COMPANY_NAME_MANDATORY: "Nome da empresa é de preenchimento obrigatório!",
	CRN_MANDATORY: "Campo CRN é de preenchimento obrigatório!",
	INVALID_FILE_TYPE:
		"Tipo de arquivo inválido, só é permitido anexar PDF ou imagens",
	REGISTER_EMAIL_WARNING:
		"Esse vai ser o email utilizado para login de usuário",

	FOLLOWUP_ANSWERED: "Respondido?",

	NO_FOLLOWUP_DATA: "Não há registro de acompanhamento",
	NO_APP_ACCESS_DATA: "Não há registro de uso do app",

	ATTACHMENT_MUST_HAVE_TYPE: 'precisa ter um "tipo de arquivo"',

	TWO_FACTOR_AUTH_MODAL_TITLE: "Etapa adicional de segurança",
	TWO_FACTOR_AUTH_SENT_MESSAGE:
		"O código de autenticação foi enviado para o seu email",
	DISPLAY_2FA_CODE: "Código de autenticação",
	SAVE: "Salvar",
	USER_CRIATION: "Criação de cliente",
	WARNING_REGISTER_USER_EMAIL:
		"Esse vai ser o email utilizado para login de usuário",
	SELECTION_MODULES: "Seleção de Módulos",
	CONFIRM_MODULES: "Confirmar módulos",
	SELECT_NEW_USER_INSTRUCTION:
		"Selecione os módulos que o cliente recém criado terá acesso",
	SKIP_STEP_INSTRUCTION: "ou pule esta etapa",
	SKIP_STEP: "Pular etapa",
	NAME: "Nome",
	DEPARTMENT: "Departamento",
	CPF: "CPF",
	EMAIL_MANDATORY: "Email é de preenchimento obrigatório!",
	CPF_MANDATORY: "CPF é de preenchimento obrigatório!",
	CPF_DIGITS_WARNING: "CPF deve conter 11 digitos",
	INVALID_EMAIL: "Favor inserir um email válido!",
	INVALID_CONFIRMED_EMAIL: '"Email" e "Confirmar email" são diferentes!',
	PASSWORD_MANDATORY: "Senha é de preenchimento obrigatório!",
	INVALID_CONFIRMED_PASSWORD: '"Senha" e "Confirmar senha" são diferentes!',
	CONFIRM_EMAIL: "Confirmar email",
	PASSWORD: "Senha",
	USER_LIST: "Lista de Usuários",
	ADMINISTRATOR_LIST: "Lista de Administradores",
	CAMPAIGN_LIST: "Lista de Campanhas",
	MODULES_LIST: "Lista de Módulos",
	MODULES_SETTINGS: "Configurações do Módulo",
	PERMISSIONS: "Permissões",
	DETAIL_USER: "Detalhe do cliente",
	DETAIL_ADMINISTRATOR: "Detalhe do administrador",
	MODULO_DILIGENCIAMENTO: "Diligenciamento",
	MANDATORY_FIELD: "Este campo é obrigatório",
	MODULE_NAME: "Nome",
	MODULE_DEPARTMENT: "Departamento",
	MODULE_DESCRIPTION: "Descrição",
	MODULE_URL: "URL",
	TWO_FACTOR_AUTH: "Autenticação por 2 fatores: ",
	GIVE_ACCESS: "Conceder Acesso",
	REMOVE_ACCESS: "Remover Acesso",

	LOGIN_TITLE: "BIOFITNESS",
	CLIENT: "Cliente",
	CLIENTS: "Empresas",
	CLIENTS_LIST: "Lista de Empresas",
	REGISTER_CLIENT: "Cadastrar empresa",
	REGISTER_CLIENT_2: "Cadastro de empresa",
	REGISTER_DATE: "Data do cadastro",
	DETAIL_CLIENT: "Detalhe da empresa",
	EDIT_CLIENT: "Edição da empresa",
	UPDATE_CLIENT_SUCCESS: "Empresa alterada com sucesso!",
	CREATE_CLIENT_SUCCESS: "Empresa criada com sucesso!",
	CREATE_NOTIFICATION_SUCCESS: "Notificação criada com sucesso!",
	IS_ACTIVE: "Ativo",
	IS_INACTIVE: "Inativo",
	SITUATION: "Situação",
	ERROR_UPDATE_CLIENT_STATUS: "Não é possível atualizar o status da empresa. ",
	ERROR_CHANGE_USER_INTEREST: "Não é possível alterar o interesse do usuário. ",
	CONFIRM_CHANGE_STATUS_CLIENT: "Tem certeza que deseja alterar o status do Interessado para cliente? Ao realizar está ação, este interessado irá aparecer na lista de clientes com 30 dias de plano.",
	CONFIRM_CHANGE_STATUS_USER: "Tem certeza que deseja alterar o Status deste Cliente? Caso ele esteja inativo, ele não poderá mais logar no aplicativo.",
	CONFIRM_CHANGE_NEED_APPOINTMENT: "Confirmar necessidade de consulta para o paciente?",
	REQUEST_PASSWORD_RESET: "Solicitar troca de senha",
	RESET_PASSWORD: "Troca de senha",
	RESET_PASSWORD_USER_CONFIRM:
		"Confirmar trocar de senha para o seguinte usuário:",

	INTERESTED: "Lista de Interessados",
	CREATOR: "Criador",
	
	PROSPECT: "INTERESSADO",

	REGISTER_USER_2: "Cadastro de usuário",
	USER_TYPE: "Tipo de usuário",
	USER_TYPE_MANDATORY: "Tipo é de preenchimento obrigatório!",
	USER_MANDATORY: "Usuário(s) é de preenchimento obrigatório!",
	TYPE_MANDATORY: "Tipo é de preenchimento obrigatório!",
	CLIENT_MANDATORY: "Empresa é de preenchimento obrigatório!",
	QUANTITY_OF_CLIENTS: "Quantidade de empresas",

	FREE_CONTENT: "Conteúdo Gratuito",

	CLEAN_FILTERS: "Limpar filtros",
	SEARCH_FILTERS: "Filtros de Consulta",
	OPEN_FILTERS: "Abrir Filtros",
	CLOSE_FILTERS: "Fechar Filtros",
	STATUS: "Status",
	ONLY_INCLUDED_QUIZ: "Apenas questionários vinculados",
	CREATE_CAMPAIGN: "Criar Campanha",
	DETAIL_CAMPAIGN: "Detalhe da Campanha",
	DAY_DETAIL: "Detalhe do Dia",
	CONTENTS: "Conteúdos",
	CLEAN_CONTENT: "Limpar conteúdos",
	DAYS_LIST: "Lista de Dias",
	QUIZ_LIST: "Lista de Questionários",
	LINKED_QUIZ_LIST: "Lista de Questionários Vinculados",
	CONTENT_LIST: "Lista de Conteúdos",
	CAMPAIGN_CREATION: "Criação de Campanha",
	TITLE: "Título",
	TITLE_AND_OR_DESCRIPTION: "Titulo e/ou descrição",
	DESCRIPTION: "Descrição",
	TITLE_MANDATORY: "Título é de preenchimento obrigatório!",
	DURATION_MANDATORY: "Duração é de preenchimento obrigatório!",
	START_DAY_MANDATORY: "Dia de início é de preenchimento obrigatório!",
	CATEGORY_MANDATORY: "Categoria é de preenchimento obrigatório!",
	SUBCATEGORY_MANDATORY: "Ao selecionar uma categoria que possui subcategoria, a subcategoria é obrigatória!",
	RANKING_TYPE_MANDATORY: "Tipo do é de preenchimento obrigatório!",
	CAMPAIGN_NOT_FOUND: "Campanha não encontrada",
	USER_NOT_FOUND: "Usuário(a) não encontrado(a)",
	DAY_NOT_FOUND: "Dia não encontrada",
	BACK_TO_CAMPAIGN_LIST: "Voltar para lista de campanhas",
	BACK_TO_CAMPAIGN_DETAIL: "Voltar para detalhe da campanha",
	CAMPAIGNS: "Campanhas",
	CAMPAIGN: "Campanha",
	CAMPAIGNS_LINKED: "Campanhas vinculadas",
	CAMPAIGNS_NOT_LINKED: "Campanhas não vinculadas",
	CAMPAIGNS_ALLREADY_LINKED: "Campanhas já vinculadas",
	LINK_CAMPAIGN_TO_CLIENT: "Vincular campanha à empresa",
	CHOOSE_CAMPAIGN: "Selecione uma campanha",
	NO_CAMPAIGNS_TO_CHOOSE: "Não há campanhas para vincular com esta empresa",
	CAMPAIGN_MANDATORY: "Campanha é de preenchimento obrigatório!",
	LINK_CAMPAIGN_SUCCESS: "Campanha vinculada com sucesso!",
	UNLINK_CAMPAIGN_SUCCESS: "Campanha desvinculada com sucesso!",
	CAMPAIGN_DURATION_CANT_BE_EDITED:"Duração das campanhas não pode ser editada",

	ADD_CONTENT: "Criar conteúdo",
	ADD_CONTENT_2: "Criação de conteúdo",
	REMOVE_CONTENT: "Remover conteúdo",
	CONFIRM_REMOVE_CONTENT: "Confirmar exclusão do conteúdo selecionado?",
	VIEW_CONTENT: "Visualizar conteúdo",
	VIEW_CONTENT_2: "Visualização de Conteúdo",
	HAS_CONTENT: "Com conteúdo",
	NO_CONTENT: "Sem conteúdo",
	CONTENT_TYPE: "Tipo de conteúdo",
	CONTENT_SIZE_WARNING: "A imagem deve ter tamanho menor que 5 Mb.",

	VIEW_QUIZ: "Visualizar Questionário",
	LINK_QUIZ: "Vincular Questionário",
	LINK_DATE: "Dia Vinculado",
	ASSOCIATE_QUIZ_SUCCESS: "Questionário vinculado com sucesso!",
	UNLINK_QUIZ: "Desvincular Questionário",
	UNLINK_QUIZ_CONFIRM: "Tem certeza que deseja desvincular o questionário",
	UNLINK_QUIZ_CONFIRM_2: "para o cliente",
	UNLINK_QUIZ_SUCCESS: "Questionário desvinculado com sucesso!",
	CATEGORY: "Categoria",
	SUBCATEGORY: "Subcategoria",
	QUANTITY_OF_QUESTIONS: "Quantidade de perguntas",
	DURATION: "Duração",
	CREATE_CONTENT: "Duração",
	LOAD_IMAGE: "Carregar Imagem",
	VIDEO_LINK: "Link do vídeo",

	UNLINK_CAMPAIGN: "Desvincular Campanha",
	CONFIRM_CHANGE_UNLINK_CAMPAIGN: "Tem certeza que deseja desvincular a campanha?",


	NO_WHITE_SPACE_WARNING: "Este campo não pode estar em branco",
	INVALID_INPUT_DATA: "Informe valores válidos",
	DETAIL_QUIZ: "Detalhe do Questionário",
	ERROR_CREATE_QUIZ:
		"Não foi possível direcionar para o detalhe do questionário. ",
	ERROR_DETAIL_QUIZ: "Não foi possível acessar detalhe do questionário. ",
	ACTIVE_OR_NOT_QUIZ: "Questionários ativos/inativos",
	LIST_QUESTIONS: "Lista de Perguntas",
	JUST_ACTIVE_QUIZZES: "Somente questionários ativos",

	ADD_QUESTION: "Adicionar pergunta",
	CREATE_QUESTION: "Criação de pergunta",
	CREATE_QUIZ: "Criação de Questionário",
	CREATE_QUIZ_2: "Criar Questionário",
	QUIZ_NO_ANSWERS: 'Ainda não há respostas para este questionário, volte novamente mais tarde!',
	DETAIL_QUESTION: "Detalhe da pergunta",
	EDIT_QUESTION: "Edição da pergunta",
	EDIT_QUESTION_2: "Editar pergunta",
	STATEMENT: "Enunciado",
	STATEMENT_MANDATORY: "Enunciado é de preenchimento obrigatório!",
	REMOVE_QUESTION: "Remover pergunta",
	CONFIRM_REMOVE_QUESTION: "Confirmar exclusão da pergunta selecionada?",

	LINK_TO_QUIZ: "Vincular Quiz",
	QUIZZES: "Questionários",
	SEARCH_QUIZZES: "Buscar Questionários",
	IN_DAYS: "em dias",

	CONTINUE_REGISTER: "Continuar cadastrando...",
	REDIRECTING_TO_ADD_QUESTIONS: "Redirecionando para criação de perguntas",

	QUESTION: "Pergunta",
	QUESTIONS: "Perguntas",
	DASHBOARD: "Dashboard",
	GENERIC_SELECT_PLACEHOLDER: "Selecione uma {0}",
	GENERIC_AUTOCOMPLETE_PLACEHOLDER: "Pesquise por um {0}",

	NOT_ANSWERED: "Não respondidas",
	ANSWERED_QUIZ: "Finalizados / Respondidos",
	ANSWERED_AT: "Respondido em",
	VIEW_DATA: "Visualizar dados",
	VIEW_ANSWERS: "Visualização de respostas",
	NO_DATA_PROVIDED: "Sem dados para visualizar",
	ANSWER: "Resposta",
	CLICK_TO_VIEW_ANSWER: "Clique em uma resposta para visualizar ela por completo",

	REDIRECTING_TO_LOGIN: "Senha redefinida com sucesso! Redirecionando para Login.",
	SHOW_CAMPAIGN_CONTENTS_DETAILS: 'Visualizar programação de conteúdos',
	SHOW_DATE: 'Data Programada',
	NEED_APPOINTMENT: 'Precisa de Consulta',
	SEARCH_FILTER: 'Filtros da Consulta',
	EXPORT_ANSWERS: 'Exportar Respostas',
	RANKING_TYPE: 'Tipo do ranking',
	RANKING_TYPE_OPTIONS: 'Opções do ranking',

	CONSULTATION_INTERESTS_DATA: 'Interesse em consulta - Data',
	CONSULTATION_INTERESTS_PROFESSIONAL: 'Interesse em consulta - Profissional',
	ONLY_CONSULTATION_INTERESTS_USERS: 'Apenas clientes que possuem interesse em consulta:',
	CONSULTATION_INTERESTS: 'Interesse em Consulta',
	CONSULTATION_INTERESTS_DATA_2: 'Data do interesse',
	PROFESSIONAL: 'Profissional',
	DONE_CONSULTING: 'Consulta realizada',
	NO_CONSULTING_INTEREST_FOUND: 'Não há interesse de consulta pelo usuário. ',
	CREATED_AT: 'Criado em',
	CHANGE_BY: 'Alterado por',

	// ========== CATÁLOGO DE EXERCÍCIOS ==========
	EXERCISE_CATALOG: 'Catálogo de Exercícios',
	EXERCISE_CATALOG_LIST: 'Lista do Catálogo de Exercícios',
	ADD_EXERCISE_CATALOG: 'Adicionar ao Catálogo',
	EDIT_EXERCISE_CATALOG: 'Editar Exercício do Catálogo',
	REMOVE_EXERCISE_CATALOG: 'Remover do Catálogo',
	CONFIRM_REMOVE_EXERCISE_CATALOG: 'Tem certeza que deseja remover este exercício do catálogo?',
	EXERCISE_CATALOG_CREATED_SUCCESS: 'Exercício adicionado ao catálogo!',
	EXERCISE_CATALOG_UPDATED_SUCCESS: 'Exercício do catálogo atualizado!',
	EXERCISE_CATALOG_REMOVED_SUCCESS: 'Exercício removido do catálogo!',
	SELECT_EXERCISE_FROM_CATALOG: 'Selecione um exercício do catálogo',
	SEARCH_EXERCISE: 'Buscar exercício...',
	INHERITED_FROM_CATALOG: 'Herdado do catálogo',
	OVERRIDE_FIELD_HINT: 'Deixe em branco para herdar do catálogo mestre',

	// ========== TREINOS ==========
	TRAININGS: 'Treinos',
	GYM_WORKOUTS: 'Treinos na Academia',
	GYM_WORKOUT: 'Treino na Academia',
	HOME_WORKOUTS: 'Treinos em Casa',
	HOME_WORKOUT: 'Treino em Casa',
	STRETCHINGS: 'Alongamentos',
	STRETCHING: 'Alongamento',
	EXERCISES: 'Exercícios',
	EXERCISE: 'Exercício',
	
	// Listagens
	GYM_WORKOUT_LIST: 'Lista de Treinos na Academia',
	HOME_WORKOUT_LIST: 'Lista de Treinos em Casa',
	STRETCHING_LIST: 'Lista de Alongamentos',
	EXERCISE_LIST: 'Lista de Exercícios',
	
	// Ações
	ADD_WORKOUT: 'Adicionar Treino',
	ADD_EXERCISE: 'Adicionar Exercício',
	VIEW_WORKOUT: 'Visualizar Treino',
	VIEW_EXERCISE: 'Visualizar Exercício',
	EDIT_WORKOUT: 'Editar Treino',
	EDIT_EXERCISE: 'Editar Exercício',
	REMOVE_WORKOUT: 'Remover Treino',
	REMOVE_EXERCISE: 'Remover Exercício',
	VIEW_EXERCISES: 'Ver Exercícios',
	
	// Confirmações
	CONFIRM_REMOVE_WORKOUT: 'Tem certeza que deseja remover este treino?',
	CONFIRM_REMOVE_EXERCISE: 'Tem certeza que deseja remover este exercício?',
	
	// Mensagens de sucesso
	WORKOUT_CREATED_SUCCESS: 'Treino criado com sucesso!',
	WORKOUT_UPDATED_SUCCESS: 'Treino atualizado com sucesso!',
	WORKOUT_REMOVED_SUCCESS: 'Treino removido com sucesso!',
	EXERCISE_CREATED_SUCCESS: 'Exercício criado com sucesso!',
	EXERCISE_UPDATED_SUCCESS: 'Exercício atualizado com sucesso!',
	EXERCISE_REMOVED_SUCCESS: 'Exercício removido com sucesso!',
	
	// Campos
	WORKOUT_NAME: 'Nome do Treino',
	EXERCISE_NAME: 'Nome do Exercício',
	GENDER: 'Gênero',
	WEEKLY_FREQUENCY: 'Frequência Semanal',
	DURATION_MINUTES: 'Duração (minutos)',
	ORDER_INDEX: 'Ordem',
	VIDEO_URL: 'URL do Vídeo',
	SETS: 'Séries',
	REPS: 'Repetições',
	REST_SECONDS: 'Descanso (segundos)',
	
	// Opções de gênero
	MALE: 'Masculino',
	FEMALE: 'Feminino',
	UNSPECIFIED: 'Não especificado',
	
	// Validações
	NAME_MANDATORY: 'Nome é obrigatório!',
	GENDER_MANDATORY: 'Gênero é obrigatório!',
	FREQUENCY_MANDATORY: 'Frequência é obrigatória!',
	WORKOUT_MANDATORY: 'Treino é obrigatório!',
	
	// Outros
	NO_EXERCISES_FOUND: 'Nenhum exercício cadastrado para este treino.',
	TIMES_PER_WEEK: 'vezes por semana',

	// ========== DIETAS (GERENCIAMENTO) ==========
	// Listagem
	DIET_MANAGEMENT: 'Gerenciamento de Dietas',
	DIET_LIST_MANAGEMENT: 'Lista de Dietas',
	
	// Ações
	ADD_DIET: 'Adicionar Dieta',
	VIEW_DIET: 'Visualizar Dieta',
	EDIT_DIET: 'Editar Dieta',
	REMOVE_DIET_ACTION: 'Remover Dieta',
	DOWNLOAD_PDF: 'Baixar PDF',
	REPLACE_PDF: 'Substituir PDF',
	
	// Campos
	DIET_TYPE: 'Tipo de Dieta',
	WEIGHT_LOSS: 'Emagrecimento',
	MUSCLE_GAIN: 'Ganho de Massa',
	MEALS_COUNT: 'Quantidade de Refeições',
	PDF_FILE: 'Arquivo PDF',
	MEALS: 'refeições',
	CURRENT_FILE: 'Arquivo Atual',
	
	// Confirmações
	CONFIRM_REMOVE_DIET: 'Tem certeza que deseja remover esta dieta?',
	
	// Validações
	DIET_TYPE_MANDATORY: 'Tipo de dieta é obrigatório!',
	MEALS_COUNT_MANDATORY: 'Quantidade de refeições é obrigatória!',
	FILE_MANDATORY: 'Arquivo PDF é obrigatório!',
	
	// Sucesso
	DIET_CREATED_SUCCESS: 'Dieta criada com sucesso!',
	DIET_UPDATED_SUCCESS: 'Dieta atualizada com sucesso!',
	DIET_REMOVED_SUCCESS: 'Dieta removida com sucesso!',
};
